import React from "react";
import { Box, useTheme } from "@mui/material";
import {
  Activity,
  Lock,
  SquareCheck,
  TriangleAlert,
  UserRoundCheck,
  UserRoundX,
} from "lucide-react";

export type StatusBadgeVariant =
  | "active"
  | "default"
  | "neutral"
  | "warning"
  | "error"
  | "absent"
  | "suspended";

interface StatusBadgeCstProps {
  label: string;
  variant?: StatusBadgeVariant;
}

const ICONS: Record<StatusBadgeVariant, React.ElementType> = {
  active: SquareCheck,
  default: Activity,
  neutral: UserRoundCheck,
  warning: TriangleAlert,
  error: TriangleAlert,
  absent: UserRoundX,
  suspended: Lock,
};

const StatusBadgeCst: React.FC<StatusBadgeCstProps> = ({
  label,
  variant = "active",
}) => {
  const theme = useTheme();

  const colors = {
    active: {
      bg: theme.palette.badge.success.background,
      fg: "#000000",
      border: `1px solid ${theme.palette.badge.success.border}`,
    },
    default: {
      bg: theme.palette.action.disabledBackground,
      fg: theme.palette.text.primary,
      border: "none",
    },
    neutral: {
      bg: theme.palette.badge.default.background,
      fg: "#000000",
      border: `1px solid ${theme.palette.badge.default.border}`,
    },
    warning: {
      bg: theme.palette.badge.warning.background,
      fg: "#000000",
      border: `1px solid ${theme.palette.badge.warning.border}`,
    },
    error: {
      bg: theme.palette.badge.error.background,
      fg: "#000000",
      border: `1px solid ${theme.palette.badge.error.border}`,
    },
    absent: {
      bg: theme.palette.badge.warning.background,
      fg: "#000000",
      border: `1px solid ${theme.palette.badge.warning.border}`,
    },
    suspended: {
      bg: theme.palette.badge.error.background,
      fg: "#000000",
      border: `1px solid ${theme.palette.badge.error.border}`,
    },
  }[variant];

  const Icon = ICONS[variant];

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "4px 10px",
        borderRadius: "4px",
        backgroundColor: colors.bg,
        color: colors.fg,
        border: colors.border,
        fontSize: "12px",
        fontWeight: 600,
        lineHeight: 1.2,
      }}
    >
      <Icon size={12} />
      {label}
    </Box>
  );
};

export default StatusBadgeCst;
